import CryptoJS from "crypto-js";

/**
 * Reads NEXT_PUBLIC_CRYPTO_SECRET, so encryption can run on both the server and the
 * client (e.g. a checkout query built inside a client component such as Switcher).
 *
 * SECURITY: the NEXT_PUBLIC_ prefix makes webpack inline the key as a string literal
 * into the client bundle — the AES secret ships to every visitor. This is an accepted
 * tradeoff here; do not put anything genuinely sensitive behind this key.
 *
 * The throw guards against a missing/misconfigured env: without it, calling this
 * would encrypt under an `undefined` key and silently emit ciphertext nothing can
 * decrypt.
 */
const getSecret = () => {
  const secret = process.env.NEXT_PUBLIC_CRYPTO_SECRET;

  if (!secret) {
    throw new Error(
      "NEXT_PUBLIC_CRYPTO_SECRET is not set. It is server-only — if this fired in the browser, " +
        "encrypt on the server and pass the result down as a prop instead."
    );
  }

  return secret;
};

export const getEncryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), getSecret()).toString();
};

export const getDecryptData = (decryptText = "") => {
  if (!decryptText) return "";

  try {
    const bytes = CryptoJS.AES.decrypt(decryptText, getSecret());
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    if (!plaintext) return "";
    return JSON.parse(plaintext);
  } catch (error) {
    console.error("getDecryptData failed", error);
    return "";
  }
};
